import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'coupon',
    serviceName: 'auth',
    query: gql`
      query coupon($ids: [String], $for_admin: Int) {
        coupon(ids: $ids, for_admin: $for_admin) {
          data {
            id
            type
            title
            amount
            status
            end_date
            start_date
            is_active
            assignment_type
            shop {
              id
              title
            }
            products_shop {
              id
              product_info {
                title
                brand {
                  title
                }
                media {
                  full_url
                }
              }
            }
            product_categories {
              id
              title
              media {
                full_url
              }
            }
            users {
              id
              lastname
              firstname
              cellphone
              media {
                full_url
              }
            }
          }
        }
      }
    `,
  },
};

export default schema;
